import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import utils  from '@/utils/utils.js';
Vue.prototype.$utils = utils;
import throttle  from '@/utils/throttle.js'; //防多次点击，重复提交
import $ from 'jquery'
Vue.prototype.$throttle = throttle;
import constant from '@/utils/constant.js'//常量文件
Vue.prototype.$constant = constant; //全局常量

//引入quill-editor编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)



Vue.use(ElementUI);
Vue.config.productionTip = false;
//注册一个全局的loading
Vue.prototype.loading = function() {
  let loading =  this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '正在加载...',                     // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.7)',       // 背景颜色
    target: 'document.body',                    // 需要遮罩的区域
    body: true,
    customClass: 'mask'                     // 遮罩层新增类名
  });
  return loading
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
